import React from 'react';
import { PeekStack, PeekTypography, PeekBox } from '@piiqtechnologies/ui-components';
import { EditorTooltip } from '../EditorTooltip.js';

const HotspotEditingTooltipDescription = ({ description }) => (React.createElement(PeekTypography, { variant: "body1", color: "inherit" },
    React.createElement(PeekStack, { direction: "row", alignItems: "center", spacing: 0.5 },
        "\u2022 \u00A0",
        description)));
const HotspotEditingTooltip = ({ title, onCloseWarningTooltip, description, }) => {
    return (React.createElement(EditorTooltip, { onCloseWarningTooltip: onCloseWarningTooltip },
        React.createElement(PeekStack, { direction: "column", spacing: 1 },
            React.createElement(PeekTypography, { variant: "h4", fontWeight: "fontWeightBold" }, title),
            React.createElement(PeekBox, null,
                React.createElement(HotspotEditingTooltipDescription, { description: description })))));
};

export { HotspotEditingTooltip, HotspotEditingTooltipDescription, HotspotEditingTooltip as default };
